module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Select retailers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bde2b1e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicPricingRule/SelectRetailersComponent.vue
// module id = 1349
// module chunks = 2